module.exports = __webpack_public_path__ + "assets/img/27.ee31c5a8.png";